import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Short } from 'src/app/model/out-fit';

import { ValidationResult, ValidationErrorKey } from 'src/app/validations/customization/customization.validation';

@Component({
  selector: 'app-customize-short',
  templateUrl: './customize-short.component.html',
  styleUrls: ['./customize-short.component.css'],
})
export class CustomizeShortComponent {
  @Input() colors!: string[];
  @Input() shortSelections!: Short;
  @Input() validationResult: ValidationResult | null = null;

  @ViewChild('svgContainer') svgContainer!: ElementRef;
  @Output() shortSelectionsChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shortSelections']) {
      setTimeout(() => {
        this.applyColorToSvg(this.shortSelections?.color);
        this.applyLogoColor(this.shortSelections?.logoColor);
      }, 100);
    }
  }

  hasError(key: ValidationErrorKey): boolean {
    return !!this.validationResult?.errorKeys.includes(key);
  }

  applyColorToSvg(color: string) {
    this.shortSelectionsChange.emit({ part: 'color', value: color });

    const path = this.svgContainer?.nativeElement.querySelector('path');

    if (path) {
      path.setAttribute('fill', color);
    }
  }

  applyLogoColor(color: string) {
    this.shortSelections.logoColor = color;
    this.shortSelectionsChange.emit({ part: 'logoColor', value: color });

    const paths = this.svgContainer?.nativeElement.querySelectorAll('#logo');
    paths?.forEach((path: Element) => {
      path.setAttribute('fill', color);
    });
  }
}
